import serviceSettingsChecklistComponent from './service_settings.checklist.component'

let serviceSettingsChecklistModule = angular.module('serviceSettingsChecklist', [])

    .component('serviceSettingsChecklist', serviceSettingsChecklistComponent)

    .name;

export default serviceSettingsChecklistModule;


// WEBPACK FOOTER //
// ./client/app/components/service_settings/service-checklist/index.js